// src/services/storageDataService.js
import { FirebaseStorage } from "@capacitor-firebase/storage";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { isNativeFirestorePlatform } from "./firestorePlatform";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getNativeDownloadUrlWithRetry = async (path) => {
  for (let i = 0; i < 20; i++) {
    try {
      const result = await FirebaseStorage.getDownloadUrl({ path });
      const url = result?.downloadUrl || result?.url;

      if (url) return url;
    } catch (err) {
      await sleep(700);
    }
  }

  throw new Error(`DownloadURL konnte nicht geladen werden: ${path}`);
};

export const uploadImageData = async (file, path) => {
  if (!file || !path) throw new Error("uploadImageData: file/path fehlt");

  if (isNativeFirestorePlatform()) {
    const uri = file.nativePath || file.uri || file.path || file.webPath;

    if (!uri) {
      throw new Error("Native Upload: Datei hat keinen nativen Pfad.");
    }

    await FirebaseStorage.uploadFile({
      path,
      uri,
      metadata: {
        contentType: file.type || "image/jpeg",
      },
    });

    return await getNativeDownloadUrlWithRetry(path);
  }

  const fileRef = ref(storage, path);

  await uploadBytes(fileRef, file, {
    contentType: file.type || "image/jpeg",
  });

  return await getDownloadURL(fileRef);
};